import React, { useRef, useState } from 'react'
import FixedView from '../FixedView'


class StageActionButton extends React.Component {

    state = {
        isOpen: false,
        actions: [
            {
                icon: "/assets/icons/applets/desk/airpod.left.svg",
                name: "Done",
                item: [
                    { title: 'test' }
                ]
            },
            {
                icon: "/assets/icons/applets/desk/square.filled.and.line.vertical.and.square.png",
                name: "Mirror",
                item: [
                    { title: 'test' }
                ]
            },
            {
                icon: "/assets/icons/applets/desk/hand.point.up.braille.svg",
                name: "Request For Permission",
                item: [
                    { title: 'test' }
                ]
            },
            {
                icon: "/assets/icons/applets/desk/trash.svg",
                name: "Remove", item: [
                    { title: 'test' }
                ]
            },
            {
                icon: "/assets/icons/applets/desk/plus.svg",
                name: "Add Subtasks",
                // item: [
                //     { title: 'test' }
                // ]
            },
            {
                icon: "/assets/icons/applets/desk/power.dotted.svg",
                name: "Start Track",
                // item: [
                //     { title: 'test' }
                // ]
            },
            {
                icon: "/assets/icons/applets/desk/pin.svg",
                name: "Pin Task",
                // item: [
                //     { title: 'test' }
                // ]
            },

        ],
    }
    openActions = () => {
        this.fixedView.showView()
        this.setState({ isOpen: !this.state.isOpen })
    }

    onHide = () => {
        this.setState({ isOpen: false })
    }


    render() {



        return (

            <div className='' >
                <div ref={el => this.currentNode = el} className={'flexcc stage-action-button cursor-pointer ' + (this.state.isOpen ? ' isOpen ' : '')} onClick={() => this.openActions()}  >
                    <img className='stage-action-button-img' src={'/assets/icons/useful/action.png'} height={10} />
                </div>

                <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={14} zIndex={5} >
                    {/* <div className=" mt-2 mld-3 py-3 px-4 d-flex flex-column w-100" style={{ minWidth: 120, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}> */}
                    <div className='actionlist shadow-2 br-10 px-2' >

                        {this.state.actions.map((prop) => {
                            return (
                                <>
                                    <div className='action-option px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'

                                    >
                                        <img src={prop.icon} />
                                        <p>
                                            {prop.name}
                                        </p>
                                    </div>

                                </>
                            )
                        })}
                    </div>
                    {/* </div> */}
                </FixedView>
            </div>


        )
    }

}

export default StageActionButton
